import api from '@/logic/api'

export default {
  getItemAnswers: () => api.get('/todolists/all-item-answers'),
  getTodolists: () => api.get('/todolists'),
  setItemAnswer: (itemId, isDone) => api.post(`/todolists/set-item/${itemId}`, { is_done: isDone }),
}
